export default "__VITE_ASSET__Bd$PY2OK__"